 
import http from "@/http/service"
 
export default function UsuarioByid(idUsuario=0){

    return http.get(`/parceiro/usuarios/${idUsuario}`)

}